"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDiveOnHitEffect = exports.EAiAbility = exports.EAiTargetType = exports.EAiState = exports.EAiMode = void 0;
var EAiMode;
(function (EAiMode) {
    EAiMode[EAiMode["None"] = 0] = "None";
    EAiMode[EAiMode["Player"] = 1] = "Player";
    EAiMode[EAiMode["AttackOnSight"] = 2] = "AttackOnSight";
    EAiMode[EAiMode["Zombie"] = 3] = "Zombie";
    EAiMode[EAiMode["Spider"] = 4] = "Spider";
})(EAiMode = exports.EAiMode || (exports.EAiMode = {}));
var EAiState;
(function (EAiState) {
    EAiState[EAiState["None"] = 0] = "None";
    EAiState[EAiState["Player"] = 1] = "Player";
    EAiState[EAiState["Sleep"] = 2] = "Sleep";
    EAiState[EAiState["ChasePlayer"] = 3] = "ChasePlayer";
    EAiState[EAiState["Stationary"] = 4] = "Stationary";
    EAiState[EAiState["Wander"] = 5] = "Wander";
    EAiState[EAiState["FleeBasic"] = 6] = "FleeBasic";
})(EAiState = exports.EAiState || (exports.EAiState = {}));
var EAiTargetType;
(function (EAiTargetType) {
    EAiTargetType[EAiTargetType["Hero"] = 0] = "Hero";
    EAiTargetType[EAiTargetType["Enemy"] = 1] = "Enemy";
})(EAiTargetType = exports.EAiTargetType || (exports.EAiTargetType = {}));
var EAiAbility;
(function (EAiAbility) {
    EAiAbility[EAiAbility["SpawnSpiderEgg"] = 0] = "SpawnSpiderEgg";
    EAiAbility[EAiAbility["SpawnSpiderWeb"] = 1] = "SpawnSpiderWeb";
})(EAiAbility = exports.EAiAbility || (exports.EAiAbility = {}));
var EDiveOnHitEffect;
(function (EDiveOnHitEffect) {
    EDiveOnHitEffect[EDiveOnHitEffect["None"] = 0] = "None";
    EDiveOnHitEffect[EDiveOnHitEffect["SlashSplit"] = 1] = "SlashSplit";
})(EDiveOnHitEffect = exports.EDiveOnHitEffect || (exports.EDiveOnHitEffect = {}));
